module.exports = __webpack_public_path__ + "img/graphs.2190d24f.svg";